import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericNumberInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';

const BookingYearInput: InputWithoutSource = ({ input }) => <GenericNumberInput label={input.name} input={input} />;

BookingYearInput.meta = {
    inputType: InputModel.name
};

export default observer(BookingYearInput);
